import { Component, Input, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-index-data',
    templateUrl: './index-data.component.html',
    styleUrls: ['./index-data.component.scss'],
    imports: [NgClass, RouterLink]
})
export class IndexDataComponent implements OnInit {

  @Input() showNav= true;
  @Input() isConsentPage= false;

  title = "Index Data Sources and Index Descriptions.";
  

  constructor(private seoservice: SeoService, private meta: Meta) { }

  ngOnInit() {

// $&("showNav",this.showNav)
// $&("isConsentPage",this.isConsentPage)
    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholic disclosures, ifc index data changes, ifc indexes'});
    this.meta.addTag({name: 'description', content: 'A list of Investing for Catholics Index Data Sources and history of changes.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
